import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useNavLinks } from "shared/hooks";
import "./FooterItems.styles.css";

function FooterItems() {
  const { footerLinks } = useNavLinks();

  return footerLinks.map(({ link, href, label }) => {
    if (href)
      return (
        <Link
          key={href}
          href={href}
          target="_blank"
          sx={{ color: "#7c9dbe;", textDecoration: "none" }}
          className="footer-link"
        >
          {label}
        </Link>
      );

    return (
      <NavLink key={link} to={link} className="footer-link">
        {label}
      </NavLink>
    );
  });
}

export default FooterItems;
